let APP_BASE_URL = 'https://leap-admin.cuemath.com/';
if (process.env.NODE_ENV !== 'production') {
  APP_BASE_URL = 'https://local-admin.cuemath.com/';
}

const AUTH_SERVICE_BASE_URL = `${APP_BASE_URL}auth/`;
const CALLBACK_URL = `${AUTH_SERVICE_BASE_URL}google-callback-standalone/?app_url=${APP_BASE_URL}`;

export const BASE_URL = '/api/v1';
export const CHATBOT_BASE_URL = `${BASE_URL}/chatbot`;
export const BASE_URL_V2 = '/api/v2';
export const BASE_V2_URL = '/api/v2/curriculum';
export const CUEMATH_URL = 'https://www.cuemath.com/';
export const SENTRY_DSN =
  'https://c6312ebf03744f4fb6241150ab0ff089@o65956.ingest.sentry.io/6055778';
export const CDN_URL = 'https://d138zd1ktt9iqe.cloudfront.net';

export const getGoogleLoginURL = () => {
  if (typeof window !== 'undefined') {
    const appBaseURL = `https://${window.location.hostname}/`;
    const authServiceBaseURL = `${appBaseURL}auth/`;
    const callBackURL = `${authServiceBaseURL}google-callback-standalone/?app_url=${appBaseURL}`;

    return `${authServiceBaseURL}google-login/?callback_url=${callBackURL}`;
  }

  return `${AUTH_SERVICE_BASE_URL}google-login/?callback_url=${CALLBACK_URL}`;
};

const ADMIN_BASE_URL = 'http://admin.cuemath.com';

export const STUDENTS_ADMIN_URL = ADMIN_BASE_URL + '/intelenrollment/admin/student/';
export const STUDENT_SLOTS_ADMIN_URL = ADMIN_BASE_URL + '/classroom/admin/studentslots/';
export const STUDENT_PAYMENT_LINK_REFUND_URL =
  ADMIN_BASE_URL +
  '/intelenrollment/admin/studentpaymentlinkrefund/pre-create/?student_payment_link_id=';
export const STUDENT_FEE_REFUND_URL =
  ADMIN_BASE_URL + '/intelenrollment/admin/studentpaymentlinkrefund/pre-create/?fee_id=';
export const STUDENT_SLOTS_REDIRECT_URL = STUDENT_SLOTS_ADMIN_URL;
export const LAPSE_LOG_ADMIN_URL =
  ADMIN_BASE_URL + '/intelenrollment/admin/studentcourselapselog/?search=';

export const USER_CONFIG = 'intel_user_config';
export const BATCHES_CONFIG = 'intel_batches_config';
export const CURRENCY_OPTIONS = 'payment_currency_options';
export const TEACHER_PERFORMANCE_REVIEW = 'teacher_performance_review';
export const DEMO_INELIGIBLE_TEACHERS = 'demo_ineligible_teacher_ids';
export const REFERRAL_CAMPAIGNS = 'referral_campaigns';

export const RESOURCE_URL = {
  students: 'students',
  studentdemos: 'classroom/student-demos',
  teachers: 'teachers',
  studentSlots: 'classroom/student-slots',
  teacherSlots: 'classroom/teacher-slots',
  studentPaymentLinks: 'students/student-payment-link',
  teacherReviews: 'teacher-classrooms',
  teacherClassroomList: 'classroom/teacher-classrooms',
};

let openTokKey = null;

if (process.env.REACT_APP_ENV === 'staging' || process.env.NODE_ENV === 'development') {
  openTokKey = '46282432';
} else {
  openTokKey = '46187592';
}
export const OPEN_TALK_KEY = openTokKey;
